import {
  IActiveBannerListRes,
  IActiveBannerListReq,
} from '@models/interfaces/microservice/cms.interface';
import { IGlobalPageRes } from '@models/interfaces/microservice/global.interface';
import axios from 'axios';
// import Cookies from "js-cookie";

const API_BASE_URL = process.env.MCS_CMS_BASE_URL;

const config = {
  baseURL: API_BASE_URL,
  withCredentials: true,
};

const API = axios.create(config);

const CMSService = {
  async get_active_banner_list(param: IActiveBannerListReq) {
    const { page, page_size, markets, sort } = param;
    const queryParams = new URLSearchParams({
      page: page.toString(),
      page_size: page_size.toString(),
      markets: markets.join(','),
      sort: sort.toString(),
    });

    return await API.get<IGlobalPageRes<IActiveBannerListRes>>(
      `/active-banners?${queryParams.toString()}`,
    );
  },
};

export default CMSService;
